import axios, { AxiosResponse } from "axios";
import { CONFIG } from "../constants/config";

export const fetcher = async (
  url: string,
  token: string | null
): Promise<any> => {
  return axios
    .get(`${CONFIG.API_BASE}${url}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    })
    .then((res: AxiosResponse) => res.data);
};

export const apiPost = async (
  url: string,
  data: any,
  token?: string | null
): Promise<any> => {
  return axios
    .post(`${CONFIG.API_BASE}${url}`, data, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    })
    .then((res: AxiosResponse) => res.data);
};

export const apiPut = async (
  url: string,
  data: any,
  token?: string
): Promise<any> => {
  return axios
    .put(`${CONFIG.API_BASE}${url}`, data, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    })
    .then((res: AxiosResponse) => res.data);
};

export const apiPatch = async (
  url: string,
  data: any,
  token?: string | null
): Promise<any> => {
  const fullUrl = `${CONFIG.API_BASE}${url}`;
  const headers = {
    Authorization: token ? `Bearer ${token}` : "",
    'Content-Type': 'application/json'
  };
  
  try {
    const response = await axios.patch(fullUrl, data, { headers });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const apiDelete = async (
  url: string,
  token?: string | null,
  data?: any
): Promise<any> => {
  return axios
    .delete(`${CONFIG.API_BASE}${url}`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
      data
    })
    .then((res: AxiosResponse) => res.data);
};
